import { Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-custom-cell-editor',
    template: `<input [(ngModel)]="value" maxLength="4" (keydown)="onKeyDown($event)" class="custom-dropdown">`,
    styles: [`
        .custom-dropdown {
            width: 100% !important;
            min-width:150px !important;
            text-align:center;
            background: #FFFFFF 0% 0% no-repeat padding-box ;
            box-shadow: inset 0px 1px 6px #00000029;
            border: 1px solid #D7DCE1;
            border-radius: 2px;
            font-size: 12px !important;
            padding: 0.4em;
            color: black;
            height: 23px !important;
            font-weight: 500;
        }
    `]
})
export class CustomCellEditorComponent implements ICellEditorAngularComp {
    private params: any;
    public value: string;
    private maxLength: number = 4; // Set your desired maximum length

    agInit(params: any): void {
        this.params = params;
        this.value = params.value;
    }

    getValue(): any {
        return this.value.toUpperCase();
    }

    onKeyDown(event: KeyboardEvent): void {
        // if (this.value.length > this.maxLength) {
        //     event.preventDefault(); // Prevent further input if max length is reached
        //     return;
        // }

        const allowedCharacters = /^[a-zA-Z0-9]+$/; // Regular expression to allow only letters and numbers

        if (!event.key.match(allowedCharacters)) {
            event.preventDefault(); // Prevent special characters
            return;
        }

        // // Disallow editing if only spaces are entered
        // if (event.key === ' ' && this.value.trim().length === 0) {
        //     event.preventDefault();
        //     return;
        // }
    }
}
